import React, { useContext, useEffect, useState } from "react";
import { AuthService } from "../utils/AuthService";
import { AuthHttpClient } from "../utils/AuthHttpClient";
import { AuthApolloClient } from "../utils/AuthApolloClient";
import { ApolloProvider } from "@apollo/client";
import { useConfig } from "./config-context";
import { useLog } from "./use-log";
const initialSecurityContext = {
  authService: {},
  authHttpClient: {},
  authApolloClient: {},
  authenticated: true,
  // Optimistic approach
  didAuthenticate: value => {},
  initialized: false
};
const SecureContext = /*#__PURE__*/React.createContext(initialSecurityContext);
const useSecureContext = () => useContext(SecureContext);
const NblocksSecureContextProvider = ({
  children
}) => {
  const config = useConfig();
  const {
    apiHost,
    graphqlPath,
    debug,
    appId
  } = config;
  const {
    log
  } = useLog();
  const [authenticated, setAuthenticated] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [authHttpClient] = useState(new AuthHttpClient(apiHost, debug, appId));
  const [authService] = useState(new AuthService(authHttpClient.httpClient, config));
  const [authApolloClient] = useState(new AuthApolloClient(`${apiHost}${graphqlPath}`, debug, appId));
  const didAuthenticate = value => {
    if (value !== authenticated) {
      setAuthenticated(value);
      log(`Did authenticate: ${value}`);
    }
  };
  useEffect(() => {
    log("Secure context entry");
    authService.checkCurrentUserAuthenticated().then(value => {
      didAuthenticate(value);
      if (!initialized) {
        setInitialized(true);
        log(`Initialized. With authenticated:${value} Will render all children`);
      }
    });
  }, []);
  const renderChildren = () => {
    if (initialized) {
      return /*#__PURE__*/React.createElement(ApolloProvider, {
        client: authApolloClient.client
      }, children);
    } else {
      return "";
    }
  };
  return /*#__PURE__*/React.createElement(SecureContext.Provider, {
    value: {
      ...initialSecurityContext,
      ...{
        authHttpClient,
        authService,
        authApolloClient,
        authenticated,
        didAuthenticate,
        initialized
      }
    }
  }, renderChildren());
};
export { NblocksSecureContextProvider, useSecureContext };